import React, { useEffect, useState, useMemo } from "react";
import Colors from "../../../Constants/Colors";
import "./../../../Constants/CommonStyle.css";
import Header from "../../../Components/Header/Header";
import CustomDropdown from "../../../Components/DropDown/CustomDropdown";
import { useLocation, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
  getExpertises,
  apiCallUsersCheckUserExistsMobileNumber,
  addNewAstrologerApiCall,
  postEditAstrologerDetails,
  apiCallUserLanguage,
  addAstrologerVirtual,
  postEditVirtualAstrologerDetails,
} from "../../../Core/Apicall";
import {
  setLoadingFalse,
  setLoadingTrue,
} from "../../../Config/Actions/loadingActions";
import "react-phone-input-2/lib/bootstrap.css";
import Icons from "../../../Constants/Icons";
import CustomDropdownWithSearch from "../../../Components/DropDown/CustomDropdownWithSearch";
import { toast } from "react-toastify";

const AVATAR_CONFIGS = {
  HEYGEN: {
    MALE: {
      ENG: { id: "5ace7983-e6b9-4801-ab05-ac68dd37b168", name: "Thaddeus", image: "https://zigzekassets.blr1.digitaloceanspaces.com/astrologer/123456/profile-pic/6852d66d-789c-41af-9644-b78bc6277850-hg_thaddeus_eng_male_avatar.png" },
      HIN: { id: "f0a9978d-634a-4063-8164-42ba6670542f", name: "Graham", image: "https://zigzekassets.blr1.digitaloceanspaces.com/astrologer/123456/profile-pic/f46c78df-26d1-4d87-afd3-865cd6728202-hg_graham_hin_male_avatar.png" },
      GUJ: { id: "9a5a4cb2-a32e-415f-8689-aa9d61acee1b", name: "Pedro", image: "https://zigzekassets.blr1.digitaloceanspaces.com/astrologer/123456/profile-pic/d1ba6a4f-7802-4269-ac51-ab9b68828c12-hg_pedro_guj_male_avatar.png" },
    },
    FEMALE: {
      ENG: { id: "65cca4cf-b7c8-4619-871f-84e2cf8b21d4", name: "Katya", image: "https://zigzekassets.blr1.digitaloceanspaces.com/astrologer/123456/profile-pic/3c7b8264-1e7a-4d10-82db-b192588934a9-hg_katya_eng_female_avatar.png" },
      HIN: { id: "63014563-22f7-4401-95db-034f3c992ec3", name: "Alessandra", image: "https://zigzekassets.blr1.digitaloceanspaces.com/astrologer/123456/profile-pic/81c713e8-e307-4216-a871-bf8c892662a4-hg_alessandra_hin_female_avatar.png" },
      GUJ: { id: "9d4d6cdd-38a1-448e-a336-1ac682ba6a27", name: "Marianne", image: "https://zigzekassets.blr1.digitaloceanspaces.com/astrologer/123456/profile-pic/88ed1b7f-eee5-4162-8c69-cfdc558dad4c-hg_marianne_red_guj_female_avatar.png" },
    },
  },
  TAVUS: {
    MALE: {
      ENG: { id: "p61b723241ee", name: "Charlie", faceId: "rf4703150052", image: "https://zigzekassets.blr1.digitaloceanspaces.com/astrologer/123456/profile-pic/702bfb5b-741e-4793-8902-06c8f241fd5c-tvs_charlie_eng_male_avatar.png" },
      HIN: { id: "pa6896850228", name: "Carter", faceId: "rca8a38779a8", image: "https://zigzekassets.blr1.digitaloceanspaces.com/astrologer/123456/profile-pic/8848374e-ce3f-469e-bbbf-8c1adc12395d-tvs_carter_hin_male_avatar.png" },
      GUJ: { id: "p2770fd22920", name: "Raj", faceId: "rf8f3aa4b33e", image: "https://zigzekassets.blr1.digitaloceanspaces.com/astrologer/123456/profile-pic/00afca13-9d28-4f57-be1d-0411fea20a7e-tvs_raj_guj_male_avatar.png" },
    },
    FEMALE: {
      ENG: { id: "p37018914501", name: "Olivia", faceId: "r9fa0878977a", image: "https://zigzekassets.blr1.digitaloceanspaces.com/astrologer/123456/profile-pic/6da7d66b-6a62-4b7d-9a1a-d734acf3549f-tvs_olivia_eng_female_avatar.png" },
      HIN: { id: "p8f55528a63b", name: "Gabby", faceId: "r291e545fd67", image: "https://zigzekassets.blr1.digitaloceanspaces.com/astrologer/123456/profile-pic/c5877e6b-6202-4d53-b72f-126321d88170-tvs_gabby_hin_female_avatar.png" },
      GUJ: { id: "pddb7e70de65", name: "Gloria", faceId: "r9664272580d", image: "https://zigzekassets.blr1.digitaloceanspaces.com/astrologer/123456/profile-pic/4f5760c0-30a7-4e42-add2-ea4211b7a2ef-tvs_divya_guj_female_avatar.png" },
    },
  },
  ANAM: {
    MALE: {
      ENG: { id: "8a339c9f-0666-46bd-ab27-e90acd0409dc", name: "Finn", image: "https://zigzekassets.blr1.digitaloceanspaces.com/astrologer/123456/profile-pic/2939d7e3-3c07-4de0-8a9f-def06242f8ee-anam_finn_eng_male_avatar.png" },
      HIN: { id: "6cc28442-cccd-42a8-b6e4-24b7210a09c5", name: "Gabriel", image: "https://zigzekassets.blr1.digitaloceanspaces.com/astrologer/123456/profile-pic/1f424204-8229-4738-973e-1158b3938359-anam_gabriel_hin_male_avatar.png" },
      GUJ: { id: "a64dd018-7dff-4f86-a623-0230f71fffa6", name: "Ved", image: "https://zigzekassets.blr1.digitaloceanspaces.com/astrologer/123456/profile-pic/e033a902-8eec-491c-8d20-e7d7b91ec956-anam_harold_guj_male_avatar.png" },
    },
    FEMALE: {
      ENG: { id: "972e0055-4a8a-4ba5-8b77-39bc0dfb6a1c", name: "Astrid", image: "https://zigzekassets.blr1.digitaloceanspaces.com/astrologer/123456/profile-pic/9cedf90b-fe36-4beb-adb8-09275b72b63b-anam_astrid_eng_female_avatar.png" },
      HIN: { id: "195d733e-58a9-40bb-a049-ac344fa70b7f", name: "Evelyn", image: "https://zigzekassets.blr1.digitaloceanspaces.com/astrologer/123456/profile-pic/311fd886-82a8-4366-b598-9c8ea727ed92-anam_evelyn_hin_female_avatar.png" },
      GUJ: { id: "20d4050b-c544-42a9-a8e9-dccf45ab03b6", name: "Preeti", image: "https://zigzekassets.blr1.digitaloceanspaces.com/astrologer/123456/profile-pic/ca99c41c-42d1-472c-8eeb-6ac1d1a34e04-anam_preeti_guj_female_avatar.png" },
    },
  },
};

const VOICE_CONFIGS = {
  MALE: {
    ENG: "630ed21c-2c5c-41cf-9d82-10a7fd668370",
    HIN: "4877b818-c7fe-4c89-b1cf-eadf8e23da72",
    GUJ: "91925fe5-42ee-4ebe-96c1-c84b12a85a32",
  },
  FEMALE: {
    ENG: "f786b574-daa5-4673-aa0c-cbe3e8534c02",
    HIN: "95d51f79-c397-46f9-b49a-23763d3eaa2d",
    GUJ: "4590a461-bc68-4a50-8d14-ac04f5923d22",
  },
};

const LANGUAGE_MAP = {
  ENG: "English",
  HIN: "Hindi",
  GUJ: "Gujarati",
};

const REVERSE_LANGUAGE_MAP = {
  "English": "ENG",
  "Hindi": "HIN",
  "Gujarati": "GUJ",
};


const GENDER_OPTIONS = ["Male", "Female"];

const getAllAvatars = () => {
  const avatars = [];

  Object.keys(AVATAR_CONFIGS).forEach(provider => {
    Object.keys(AVATAR_CONFIGS[provider]).forEach(gender => {
      Object.keys(AVATAR_CONFIGS[provider][gender]).forEach(language => {
        const avatar = AVATAR_CONFIGS[provider][gender][language];
        avatars.push({
          ...avatar,
          provider: provider.toLowerCase(),
          gender: gender,
          language: language,
          label: `${provider} - ${avatar.name} (${gender.charAt(0) + gender.slice(1).toLowerCase()}/${language})`,
          voiceId: VOICE_CONFIGS[gender]?.[language] || "",
        });
      });
    });
  });

  return avatars;
};

function AddAgentAstrologers() {
  const location = useLocation();
  const { data, dataEdit } = location.state || {};
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [userExpertiesRole, setUserExpertiesRole] = useState([]);
  const isProfile = useSelector((state) => state.isProfileData);
  const [mobileExisting, setMobileExisting] = useState(false);
  const [emailExisting, setEmailExisting] = useState(false);
  const [languageList, setLanguageList] = useState([]);

  const [formErrors, setFormErrors] = useState({
    firstName: false,
    lastName: false,
    displayname: false,
    email: false,
    userRole: false,
    gender: false,
    experience: false,
    expertise: false,
    mobileCode: false,
    productImage: false,
    avatarId: false,
    voiceId: false,
    mobileNumber: false,
    bio: false,
    // accountHolderName: false,
    // bankAccountNumber: false,
    // ifscCodeNumber: false,
    // bankName: false,
    priceperminut: false,
    astrologercharge: false,
    zigzekmargin: false,
    marginpercentage: false,
    discountprice: false,
    discount_percentage: false,
  });

  const [formData, setFormData] = useState({
    Languages: data?.Languages ?? [],
    firstName: data?.firstName ?? "",
    lastName: data?.lastName ?? "",
    displayname: data?.displayname ?? "",
    email: data?.email ?? "",
    mobileCode: data?.mobileCode ?? "+91",
    mobileNumber: JSON.stringify(data?.mobileNumber) ?? "",
    productImage: data?.productImage ?? "",
    gender: data?.gender ?? "",
    experience: data?.experience ?? "",
    expertise: data?.expertise ?? [],
    userRole: data?.userRole ?? "",
    bio: data?.bio ?? "",
    aadharNumber: JSON.stringify(data?.aadharNumber) ?? "",
    aadharImageFrontSide: data?.aadharImageFrontSide ?? "",
    aadharImageBackSide: data?.aadharImageBackSide ?? "",
    pancardNumber: data?.pancardNumber ?? "",
    panCardImage: data?.panCardImage ?? "",
    // accountHolderName: data?.accountHolderName ?? "",
    // bankAccountNumber: data?.bankAccountNumber ?? "",
    // ifscCodeNumber: data?.ifscCodeNumber ?? "",
    // bankName: data?.bankName ?? "",
    priceperminut: data?.priceperminut ?? "",
    astrologercharge: data?.astrologercharge ?? "",
    zigzekmargin: data?.zigzekmargin ?? "",
    marginpercentage: data?.marginpercentage ?? "",
    discountprice: data?.discountprice ?? "",
    discount_percentage: data?.discount_percentage ?? "",
    avatarId: data?.avatarId ?? "",
    voiceId: data?.voiceId ?? "",
    faceId: data?.faceId ?? "",
    selectedAvatarId: data?.avatarId ?? null,
  });

  const allAvatars = useMemo(() => getAllAvatars(), []);

  const onApiCallLanguageList = () => {
    dispatch(setLoadingTrue());
    apiCallUserLanguage()
      .then((response) => {
        const languages = response?.Languages || [];
        setLanguageList(languages);
        let updatedLanguages = languages.map((item) => ({
          ...item,
          selected: dataEdit && data?.Languages
            ? data.Languages.some((lang) => lang.id === item._id)
            : false,
        }));

        setFormData((prevFormData) => ({
          ...prevFormData,
          Languages: updatedLanguages,
        }));
        dispatch(setLoadingFalse());
      })
      .catch((err) => {
        dispatch(setLoadingFalse());
      });
  };

  useEffect(() => {
    onApiCallLanguageList();
    onApiCallGetExpiertes();
  }, []);


  const onApiCallExistingMobileNumber = async (item) => {
    let param = {
      Email: formData.email,
      Mobile: formData.mobileNumber,
      countryCode: formData.mobileCode,
      checkType: item,
    };

    try {
      const response = await apiCallUsersCheckUserExistsMobileNumber(param);
      if (item == "Email") {
        setEmailExisting(
          data?.email == formData.email ? false : response?.isEmailExists
        );
      } else {
        setMobileExisting(
          data?.mobileNumber == formData.mobileNumber
            ? false
            : response?.isMobileExists
        );
      }
    } catch (err) {
    } finally {
      dispatch(setLoadingFalse());
    }
  };

  const onApiCallGetExpiertes = () => {
    dispatch(setLoadingTrue());
    getExpertises()
      .then((response) => {
        setUserExpertiesRole(
          response.Expertises.map((expertise) => expertise?.ExpertiseName)
        );
        const updatedList = response?.Expertises.map((expertise) => ({
          ...expertise,
          selected: dataEdit && data?.expertise
            ? data.expertise.some(
              (item) => item.expertiseId === expertise._id
            )
            : false,
        }));
        setFormData((prevFormData) => ({
          ...prevFormData,
          expertise: updatedList,
        }));
        dispatch(setLoadingFalse());
      })
      .catch((err) => {
        dispatch(setLoadingFalse());
      });
  };

  const handleItemClick = (index) => {
    const updatedServiceData = formData.expertise.map((item, i) => {
      if (i === index) {
        return { ...item, selected: !item.selected };
      }
      return item;
    });
    setFormData((prevFormData) => ({
      ...prevFormData,
      expertise: updatedServiceData,
    }));
  };

  const handleInputChange = (e, fieldName) => {
    let value = e.target.value;

    if (
      fieldName == "priceperminut" ||
      fieldName == "discount_percentage" ||
      fieldName == "discountprice" ||
      fieldName == "marginpercentage" ||
      fieldName == "astrologercharge" ||
      fieldName == "zigzekmargin"
    ) {
      value = value.replace(/[^0-9]/g, "");

      if (fieldName == "discountprice") {
        if (parseInt(value, 10) > parseInt(formData.priceperminut, 10)) {
          alert("Discount price cannot be greater than price per minute");
          return;
        }
      } else if (fieldName == "priceperminut") {
        if (parseInt(value, 10) < parseInt(formData.discountprice, 10)) {
          setFormData({
            ...formData,
            [fieldName]: value,
            discountprice: "",
            zigzekmargin: "",
          });
          return;
        }
      } else if (fieldName == "zigzekmargin") {
        let discountPriceValue = parseInt(formData.discountprice || "0", 10);
        let zigzekMarginValue = parseInt(value || "0", 10);
        let additionValue = discountPriceValue + zigzekMarginValue;
        if (
          parseInt(value || "0", 10) >
          parseInt(formData.discountprice || "0", 10)
        ) {
          if (additionValue > 100) {
            alert(
              "The sum of discount price and zigzek margin cannot exceed 100"
            );
            return;
          }
          return;
        }
      }
    }

    if (
      fieldName === "mobileNumber" ||
      fieldName == "experience" ||
      fieldName == "priceperminut" ||
      fieldName == "discount_percentage" ||
      fieldName == "discountprice" ||
      fieldName == "marginpercentage" ||
      fieldName == "astrologercharge" ||
      fieldName == "zigzekmargin" ||
      fieldName == "bankAccountNumber"
    ) {
      if (!/^\d*$/.test(value)) {
        return;
      }
    }

    if (fieldName == "discountprice") {
      let data = (value * 100) / formData.priceperminut;
      let marginPer = (formData.zigzekmargin * 100) / value;

      let zigzekMarginn =
        parseInt(value || "0", 10) > parseInt(formData.zigzekmargin || "0", 10)
          ? parseInt(value || "0", 10) -
          parseInt(formData.zigzekmargin || "0", 10)
          : parseInt(formData.zigzekmargin || "0", 10) -
          parseInt(value || "0", 10);
      if (!isFinite(marginPer)) {
        marginPer = 0;
      }
      if (!isFinite(zigzekMarginn)) {
        zigzekMarginn = 0;
      }

      let finalDis = 100 - data.toFixed(2);

      if (!isFinite(finalDis)) {
        finalDis = 0;
      }
      setFormData({
        ...formData,
        [fieldName]: value,
        discount_percentage: finalDis.toFixed(2),
        marginpercentage: marginPer.toFixed(2),
        astrologercharge: zigzekMarginn.toFixed(2),
        zigzekmargin: "",
      });
    } else if (fieldName == "priceperminut") {
      let data = (formData.discountprice * 100) / value;

      let astroCharge = value - formData.zigzekmargin;
      let marchingPer = (formData.zigzekmargin * 100) / value;
      let disFinal = 100 - data;
      if (!isFinite(astroCharge)) {
        astroCharge = 0;
      }
      if (!isFinite(marchingPer)) {
        marchingPer = 0;
      }
      if (!isFinite(disFinal)) {
        disFinal = 0;
      }
      setFormData({
        ...formData,
        [fieldName]: value,
        discount_percentage: disFinal.toFixed(2),
        marginpercentage: marchingPer.toFixed(2),
        astrologercharge: astroCharge.toFixed(2),
      });
    } else if (fieldName == "zigzekmargin") {
      let data = formData.discountprice - value;
      let data2 = (value * 100) / formData.discountprice;
      if (!isFinite(data2)) {
        data2 = 0;
      }
      if (!isFinite(data)) {
        data = 0;
      }
      setFormData({
        ...formData,
        [fieldName]: value,
        marginpercentage: data2.toFixed(2),
        astrologercharge: data.toFixed(2),
      });
    } else {
      setFormData({
        ...formData,
        [fieldName]: value,
      });
    }
  };



  const handleAvatarSelect = (avatar) => {
    const selectedGender = avatar.gender.charAt(0) + avatar.gender.slice(1).toLowerCase();
    const languageName = LANGUAGE_MAP[avatar.language] || avatar.language;
    const selectedLanguage = languageList.find(
      (lang) => lang.LanguageName === languageName
    );

    const updatedLanguages = languageList.map((item) => ({
      ...item,
      selected: item._id === selectedLanguage?._id,
    }));

    setFormData((prevFormData) => ({
      ...prevFormData,
      selectedAvatarId: avatar.id,
      avatarId: avatar.id,
      voiceId: avatar.voiceId,
      faceId: avatar.faceId || "",
      productImage: avatar.image,
      gender: selectedGender,
      Languages: updatedLanguages,
    }));
  };

  const validateForm = () => {
    const errors = {
      firstName: formData.firstName == "",
      email: !/\S+@\S+\.\S+/.test(formData.email),
      lastName: formData.lastName == "",
      displayname: formData.displayname == "",
      gender: formData.gender == "",
      experience: formData.experience == "",
      userRole: formData.userRole == "",
      productImage: formData.productImage == "",
      avatarId: formData.avatarId == "",
      voiceId: formData.voiceId == "",
      // accountHolderName: formData.accountHolderName == "",
      // bankAccountNumber: formData.bankAccountNumber == "",
      // ifscCodeNumber: formData.ifscCodeNumber == "",
      // bankName: formData.bankName == "",
      priceperminut: formData.priceperminut == "",
      astrologercharge: formData.astrologercharge == "",
      zigzekmargin: formData.zigzekmargin == "",
      marginpercentage: formData.marginpercentage == "",
      discountprice: formData.discountprice == "",
      discount_percentage: formData.discount_percentage == "",
    };
    setFormErrors(errors);
    return !Object.values(errors).some((error) => error);
  };

  const onClickSave = () => {
    if (validateForm()) {
      if (!emailExisting && !mobileExisting) {
        let selectedLanguages = formData?.Languages.filter(
          (item) => item.selected
        );

        let newArrayLanguage = selectedLanguages.map((item) => {
          return {
            id: item._id,
            language: item.LanguageName,
          };
        });

        if (newArrayLanguage.length == 0) {
          alert("Please Select Language");
          return;
        }

        let selectedExperties = formData.expertise.filter(
          (item) => item.selected
        );
        let newArray = selectedExperties.map((item) => {
          return {
            expertiseId: item._id,
            expertise: item.ExpertiseName,
          };
        });

        if (newArray.length == 0) {
          alert("Please Select expertise's");
          return;
        }

        let param = {
          firstname: formData.firstName,
          lastname: formData.lastName,
          Email: formData.email,
          Mobile: formData.mobileNumber,
          profileUrl: formData.productImage,
          gender: formData.gender,
          experience: formData.experience,
          expertise: newArray,
          Bio: formData.bio,
          countryCode: formData.mobileCode,
          Languages: newArrayLanguage,
          display_name: formData.displayname,
          userRole: formData.userRole,
          avatarId: formData.avatarId,
          voiceId: formData.voiceId,
          faceId: formData.faceId || null,
          price_per_minute: formData.priceperminut,
          astrologer_charge: formData.astrologercharge,
          zigzek_margin: formData.zigzekmargin,
          zigzak_margin_percentage: formData.marginpercentage,
          discount_price: formData.discountprice,
          discount_percentage: formData.discount_percentage,
          // bank_account_holder_name: formData.accountHolderName,
          // bank_account_number: formData.bankAccountNumber,
          // ifsc_code: formData.ifscCodeNumber,
          // bank_name: formData.bankName,
          isReadyForOnBoard: true

        };
        dispatch(setLoadingTrue());
        if (dataEdit) {
          param.astrologerId = data.astrologerId;
          postEditVirtualAstrologerDetails(param)
            .then((response) => {
              dispatch(setLoadingFalse());
              toast.success("Virtual Astrologer Edit successfully!")
              navigate(-1);
            })
            .catch((err) => {
              dispatch(setLoadingFalse());
              alert("Error adding astrologer");
            });

        } else {
          addAstrologerVirtual(param)
            .then((response) => {
              dispatch(setLoadingFalse());
              toast.success("Virtual Astrologer added successfully!")
              navigate(-1);
            })
            .catch((err) => {
              dispatch(setLoadingFalse());
              alert("Error adding astrologer");
            });
        }
      }
    }
  };

  const onClickDiscardAstrologer = () => {
    navigate(-1);
    dispatch(setLoadingFalse());
  };

  return (
    <div
      style={{
        padding: 20,
        backgroundColor: Colors.darkBlack,
      }}
    >
      <Header name={`${dataEdit ? "Astrologers / Edit Agent Astrologer" : "Astrologers / Add Agent Astrologer"}`} />
      <div
        style={{
          display: "flex",
          borderRadius: "10px",
          padding: "10px",
          alignItems: "center",
          background: Colors.mainDarkColor,
          justifyContent: "space-between",
        }}
      >
        <div className="fontSize24" style={{ fontWeight: 400 }}>
          {`${dataEdit ? "Edit" : "Add"} Astrologer`}
        </div>
        <div style={{ display: "flex", gap: 10 }}>
          <div
            onClick={() => onClickDiscardAstrologer()}
            className="fontSize16"
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              fontWeight: 500,
              border: "1px solid #ffffff10",
              borderRadius: "50px",
              padding: "4px 10px 4px 10px",
              cursor: "pointer",
            }}
          >
            Discard
          </div>
          <div
            className="fontSize16"
            style={{
              cursor: "pointer",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              fontWeight: 500,
              border: "1px solid #ffffff10",
              background: "#FFF",
              color: "#1E1E25",
              borderRadius: "50px",
              padding: "4px 10px 4px 10px",
            }}
            onClick={() => onClickSave()}
          >
            Save
          </div>
        </div>
      </div>
      <div
        style={{
          maxHeight: window.innerHeight - 150,
          paddingBottom: "20px",
          marginTop: "20px",
        }}
        className="scrollable-container"
      >
        <div className="add-inventory-container">
          <div style={{}}>
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                gap: "1rem",
                fontSize: "1rem",
              }}
            >
              <div
                style={{ marginTop: "20px", background: "#25252D" }}
                className="add-inventory-main-div-section"
              >
                <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "15px" }}>
                  <div className="fontSize20" style={{ fontWeight: 600, color: "#FFF" }}>
                    Select Avatar
                  </div>
                  <div style={{ fontSize: "12px", color: "#FFFFFF66" }}>
                    Click on an avatar to select
                  </div>
                </div>

                <div style={{
                  display: "grid",
                  gridTemplateColumns: "repeat(auto-fill, minmax(140px, 1fr))",
                  gap: "12px",
                  marginBottom: "20px",
                  maxHeight: "300px",
                  overflowY: "auto",
                  padding: "5px",
                  scrollbarWidth: "thin",
                  scrollbarColor: "#848487 #25252D",
                }}
                  className="custom-avatar-scrollbar"
                >
                  {allAvatars.map((avatar, index) => {
                    const isSelected = formData.selectedAvatarId === avatar.id;
                    const languageFullName = LANGUAGE_MAP[avatar.language] || avatar.language;

                    return (
                      <div
                        key={index}
                        onClick={() => handleAvatarSelect(avatar)}
                        style={{
                          cursor: "pointer",
                          padding: "10px",
                          borderRadius: "10px",
                          background: isSelected ? "#4CAF5015" : "transparent",
                          border: isSelected ? "2px solid #4CAF50" : "1px solid rgba(255,255,255,0.1)",
                          transition: "all 0.2s ease",
                          textAlign: "center",
                          position: "relative",
                        }}
                        onMouseEnter={(e) => {
                          if (!isSelected) {
                            e.currentTarget.style.background = "#FFFFFF10";
                          }
                        }}
                        onMouseLeave={(e) => {
                          if (!isSelected) {
                            e.currentTarget.style.background = "transparent";
                          }
                        }}
                      >
                        {isSelected && (
                          <div style={{
                            position: "absolute",
                            top: "-6px",
                            right: "-6px",
                            background: "#4CAF50",
                            borderRadius: "50%",
                            width: "20px",
                            height: "20px",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            fontSize: "12px",
                            color: "#FFF",
                          }}>
                            ✓
                          </div>
                        )}
                        <img
                          src={avatar.image}
                          alt={avatar.name}
                          style={{
                            width: "80px",
                            height: "80px",
                            borderRadius: "50%",
                            objectFit: "cover",
                            border: isSelected ? "3px solid #4CAF50" : "2px solid rgba(255,255,255,0.2)",
                            marginBottom: "8px",
                          }}
                          onError={(e) => {
                            e.target.src = Icons.ic_upload_photo;
                          }}
                        />
                        <div style={{
                          fontSize: "11px",
                          color: isSelected ? "#4CAF50" : "#FFF",
                          fontWeight: isSelected ? 600 : 400,
                        }}>
                          {avatar.gender === "MALE" ? "Male" : "Female"} • {languageFullName}
                        </div>
                      </div>
                    );
                  })}
                </div>
                <div style={{ display: "flex", gap: "20px", marginTop: "15px" }}>
                  <div className="modal-second-div-title" style={{ flex: 1 }}>
                    <div className="fontSize16">
                      Avatar ID (Auto-filled)
                    </div>
                    <div
                      style={{
                        marginTop: "5px",
                        border: formErrors.avatarId
                          ? "1px solid red"
                          : "1px solid rgba(255, 255, 255, 0.2)",
                        opacity: 0.7,
                      }}
                      className="modal-coupon-code-type"
                    >
                      <input
                        className="modal-dropdown"
                        type="text"
                        placeholder="Enter Avatar ID"
                        value={formData.avatarId}
                        disabled={true}
                        style={{
                          color: "#FFF",
                          cursor: "not-allowed",
                          background: "transparent",
                        }}
                      />
                    </div>
                  </div>
                  <div className="modal-second-div-title" style={{ flex: 1 }}>
                    <div className="fontSize16">
                      Voice ID (Auto-filled)
                    </div>
                    <div
                      style={{
                        marginTop: "5px",
                        border: formErrors.voiceId
                          ? "1px solid red"
                          : "1px solid rgba(255, 255, 255, 0.2)",
                        opacity: 0.7,
                      }}
                      className="modal-coupon-code-type"
                    >
                      <input
                        className="modal-dropdown"
                        type="text"
                        placeholder="Enter Voice ID"
                        value={formData.voiceId}
                        disabled={true}
                        style={{
                          color: "#FFF",
                          cursor: "not-allowed",
                          background: "transparent",
                        }}
                      />
                    </div>
                  </div>
                </div>

                <div style={{ display: "flex", gap: "20px", marginTop: "5px" }}>
                  <div className="modal-second-div-title" style={{ flex: 1 }}>
                    <div className="fontSize16">
                      Face ID (Optional)
                    </div>
                    <div
                      style={{
                        marginTop: "5px",
                        border: formErrors.faceId
                          ? "1px solid red"
                          : "1px solid rgba(255, 255, 255, 0.2)",
                        opacity: 0.7,
                      }}
                      className="modal-coupon-code-type"
                    >
                      <input
                        className="modal-dropdown"
                        type="text"
                        placeholder="Enter Face ID"
                        value={formData.faceId}
                        disabled={true}
                        style={{
                          color: "#FFF",
                          cursor: "not-allowed",
                          background: "transparent",
                        }}
                      />
                    </div>
                  </div>
                  {/* <div className="modal-second-div-title" style={{ flex: 1 }}>
                    <div className="fontSize16">
                      Session Type
                    </div>
                    <div
                      style={{
                        marginTop: "5px",
                        zIndex: 1,
                        padding: "2.5px 10px 2.5px 10px",
                        border: formErrors.sessionType
                          ? "1px solid red"
                          : "1px solid rgba(255, 255, 255, 0.2)",
                      }}
                      className="modal-from-to-div"
                    >
                      <CustomDropdown
                        customLabelStyle={{
                          color: formData?.sessionType ? "#FFF" : "#FFFFFF33",
                          fontSize: "0.75rem",
                          fontWeight: "normal",
                        }}
                        dropDownLabel={
                          formData?.sessionType == ""
                            ? "Select Session Type"
                            : formData?.sessionType
                        }
                        items={["call", "chat", "video"]}
                        onSelect={(value) => {
                          setFormData((prevFormData) => ({
                            ...prevFormData,
                            sessionType: value,
                          }));
                        }}
                      />
                    </div>
                  </div> */}
                </div>
              </div>

              <div
                style={{ marginTop: "20px", background: "#25252D" }}
                className="add-inventory-main-div-section"
              >
                <div className="">
                  <div style={{}} className="fontSize16">
                    First name
                  </div>
                  <div
                    style={{
                      marginTop: "5px",
                      border: formErrors.firstName
                        ? "1px solid red"
                        : "1px solid rgba(255, 255, 255, 0.2)",
                    }}
                    className="modal-coupon-code-type"
                  >
                    <input
                      maxLength={30}
                      className="modal-dropdown"
                      type="text"
                      placeholder="eg. Rudraksha"
                      value={formData.firstName}
                      onChange={(e) => handleInputChange(e, "firstName")}
                    />
                  </div>
                </div>
                <div style={{}} className="modal-second-div-title">
                  <div style={{}} className="fontSize16">
                    Last name
                  </div>
                  <div
                    style={{
                      marginTop: "5px",
                      border: formErrors.lastName
                        ? "1px solid red"
                        : "1px solid rgba(255, 255, 255, 0.2)",
                    }}
                    className="modal-coupon-code-type"
                  >
                    <input
                      maxLength={30}
                      className="modal-dropdown"
                      type="text"
                      placeholder="eg. Maynk"
                      value={formData.lastName}
                      onChange={(e) => handleInputChange(e, "lastName")}
                    />
                  </div>
                </div>
                <div style={{}} className="modal-second-div-title">
                  <div style={{}} className="fontSize16">
                    Email
                  </div>
                  <div
                    style={{
                      marginTop: "5px",
                      border: formErrors.email
                        ? "1px solid red"
                        : "1px solid rgba(255, 255, 255, 0.2)",
                    }}
                    className="modal-coupon-code-type"
                  >
                    <input
                      className="modal-dropdown"
                      type="text"
                      placeholder="eg. maynk@gmail.com"
                      value={formData.email}
                      onChange={(e) => handleInputChange(e, "email")}
                      onBlur={() => onApiCallExistingMobileNumber("Email")}
                    />
                  </div>
                </div>
                {emailExisting && (
                  <div
                    style={{
                      display: "flex",
                      width: "40vh",
                      marginLeft: 5,
                      color: "#FF5733",
                      fontSize: "13px",
                    }}
                  >
                    This email has already registered
                  </div>
                )}

                <div style={{}} className="modal-second-div-title">
                  <div className="fontSize16">Country code</div>

                  <div style={{ display: "flex", gap: "0.7rem" }}>
                    <div
                      style={{ zIndex: 1, flex: 0.1 }}
                      className="modal-from-to-div"
                    >
                      <CustomDropdownWithSearch
                        customLabelStyle={{
                          color: formData?.mobileCode ? "#FFF" : "#FFFFFF33",
                          fontSize: "0.75rem",
                          fontWeight: "normal",
                        }}
                        dropDownLabel={
                          formData?.mobileCode
                        }
                        items={["+91", "+97", "+99"]}
                        onSelect={(value) => {
                          setFormData((prevFormData) => ({
                            ...prevFormData,
                            mobileCode: value,
                          }));
                        }}
                      />
                    </div>
                    <input
                      style={{
                        flex: 1,
                        border: formErrors.mobileNumber
                          ? "1px solid red"
                          : "1px solid rgba(255, 255, 255, 0.2)",
                      }}
                      className="modal-second-dropdown"
                      type="text"
                      maxLength={10}
                      placeholder="Enter 10 digit number"
                      value={formData.mobileNumber}
                      onChange={(e) => handleInputChange(e, "mobileNumber")}
                      onBlur={() => onApiCallExistingMobileNumber("Mobile")}
                    />
                  </div>
                  {mobileExisting && (
                    <div
                      style={{
                        display: "flex",
                        width: "40vh",
                        marginLeft: 5,
                        color: "#FF5733",
                        fontSize: "13px",
                      }}
                    >
                      This mobile number has already registered
                    </div>
                  )}
                </div>

                <div className="modal-second-div-title">
                  <div className="fontSize16">
                    Profile Image
                  </div>
                  <div
                    style={{
                      marginTop: "5px",
                      alignSelf: "stretch",
                      borderRadius: "16px",
                      border: formErrors.productImage
                        ? "1px dashed red"
                        : "1px dashed rgba(255, 255, 255, 0.2)",
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      padding: "0.7rem 0.7rem",
                      gap: "0.5rem",
                      color: "rgba(255, 255, 255, 0.5)",
                      backgroundColor: "rgba(255,255,255,0.05)",
                      cursor: "default",
                    }}
                  >
                    <div style={{ position: "relative" }}>
                      <img
                        style={{
                          position: "relative",
                          width: formData.productImage == "" ? "7rem" : "10rem",
                          height: formData.productImage == "" ? "7rem" : "10rem",
                          objectFit: "cover",
                          borderRadius: "5px",
                          opacity: formData.productImage ? 1 : 0.5,
                        }}
                        alt="Profile"
                        src={
                          formData.productImage
                            ? formData.productImage
                            : Icons.ic_upload_photo
                        }
                      />
                    </div>
                    {!formData.productImage && (
                      <div
                        style={{ color: "#FFFFFF80", textAlign: "center" }}
                        className="fontSize16"
                      >
                        Select an avatar above
                        <br />
                        <span style={{ fontSize: "0.7rem" }}>
                          (Image auto-filled from avatar)
                        </span>
                      </div>
                    )}
                    {formData.productImage && (
                      <div style={{ fontSize: "11px", color: "#FFFFFF66", marginTop: "4px" }}>
                        Image auto-loaded from avatar selection
                      </div>
                    )}
                  </div>
                </div>
              </div>

              <div
                style={{ background: "#25252D" }}
                className="add-inventory-main-div-section"
              >
                <div
                  style={{ display: "flex", justifyContent: "space-between" }}
                >
                  <div className="fontSize24" style={{ fontWeight: 700 }}>
                    About astrologer
                  </div>
                </div>
                <div className="">
                  <div style={{ marginTop: 5 }} className="fontSize16">
                    Display Name
                  </div>
                  <div
                    style={{
                      marginTop: "5px",
                      border: formErrors.displayname
                        ? "1px solid red"
                        : "1px solid rgba(255, 255, 255, 0.2)",
                    }}
                    className="modal-coupon-code-type"
                  >
                    <input
                      maxLength={30}
                      className="modal-dropdown"
                      type="text"
                      placeholder="Display Name"
                      value={formData.displayname}
                      onChange={(e) => handleInputChange(e, "displayname")}
                    />
                  </div>
                </div>
                <div style={{ display: "flex", gap: "20px", zIndex: 1 }}>
                  <div className="modal-second-div-title" style={{ flex: 1 }}>
                    <div className="fontSize16">
                      Astrologer role
                    </div>
                    <div
                      style={{
                        zIndex: 1,
                        padding: "2.5px 10px 2.5px 10px",
                        marginTop: "5px",
                        border: formErrors.userRole
                          ? "1px solid red"
                          : "1px solid rgba(255, 255, 255, 0.2)",
                      }}
                      className="modal-from-to-div"
                    >
                      <CustomDropdown
                        customLabelStyle={{
                          color: formData?.userRole ? "#FFF" : "#FFFFFF33",
                          fontSize: "0.75rem",
                          fontWeight: "normal",
                        }}
                        dropDownLabel={
                          formData?.userRole == ""
                            ? "Select Astrologer Role"
                            : formData?.userRole
                        }
                        items={userExpertiesRole}
                        onSelect={(value) => {
                          setFormData((prevFormData) => ({
                            ...prevFormData,
                            userRole: value,
                          }));
                        }}
                      />
                    </div>
                  </div>

                  <div className="modal-second-div-title" style={{ flex: 1 }}>
                    <div className="fontSize16">
                      Experience
                    </div>
                    <div
                      style={{
                        marginTop: "5px",
                        border: formErrors.experience
                          ? "1px solid red"
                          : "1px solid rgba(255, 255, 255, 0.2)",
                      }}
                      className="modal-coupon-code-type"
                    >
                      <input
                        maxLength={2}
                        className="modal-dropdown"
                        type="text"
                        placeholder="Experience in years"
                        value={formData.experience}
                        onChange={(e) => handleInputChange(e, "experience")}
                      />
                    </div>
                  </div>
                </div>

                <div
                  style={{ display: "flex", marginTop: "10px", gap: "20px" }}
                >
                  <div className="modal-second-div-title" style={{ flex: 1 }}>
                    <div className="fontSize16">
                      Languages
                    </div>

                    <div
                      style={{
                        marginTop: "5px",
                        display: "flex",
                        flexWrap: "wrap",
                      }}
                    >
                      {formData?.Languages.map((item, index) => {
                        return (
                          <div
                            key={index}
                            style={{
                              background: item.selected
                                ? "#FFF"
                                : "transparent",
                              margin: "5px",
                              cursor: "default",
                              border: "1px solid #ffffff10",
                              borderRadius: "15px",
                              padding: "7px 10px 7px 10px",
                              color: item.selected ? "#000" : "#FFF",
                              opacity: item.selected ? 1 : 0.6,
                            }}
                            className="expertice-list-font"
                          >
                            {item?.LanguageName}
                          </div>
                        );
                      })}
                    </div>
                    <div style={{ fontSize: "11px", color: "#FFFFFF66", marginTop: "4px" }}>
                      Language auto-selects based on avatar selection
                    </div>
                  </div>

                  <div className="modal-second-div-title" style={{ flex: 1 }}>
                    <div className="fontSize16">
                      Gender
                    </div>
                    <div
                      style={{
                        marginTop: "5px",
                        display: "flex",
                        flexWrap: "wrap",
                      }}
                    >
                      {GENDER_OPTIONS.map((gender, index) => {
                        const isSelected = formData.gender === gender;
                        return (
                          <div
                            key={index}
                            style={{
                              background: isSelected ? "#FFF" : "transparent",
                              margin: "5px",
                              cursor: "default",
                              border: "1px solid #ffffff10",
                              borderRadius: "15px",
                              padding: "7px 15px 7px 15px",
                              color: isSelected ? "#000" : "#FFF",
                              fontWeight: isSelected ? 500 : 400,
                              opacity: isSelected ? 1 : 0.6,
                            }}
                            className="expertice-list-font"
                          >
                            {gender}
                          </div>
                        );
                      })}
                    </div>
                    <div style={{ fontSize: "11px", color: "#FFFFFF66", marginTop: "4px" }}>
                      Gender auto-selects based on avatar selection
                    </div>
                  </div>
                </div>

                <div
                  style={{ display: "flex", marginTop: "10px", gap: "20px" }}
                >
                  <div className="modal-second-div-title" style={{ flex: 1 }}>
                    <div className="fontSize16">
                      Expertise
                    </div>

                    <div
                      style={{
                        marginTop: "5px",
                        display: "flex",
                        flexWrap: "wrap",
                      }}
                    >
                      {formData.expertise.map((item, index) => {
                        return (
                          <div
                            key={index}
                            onClick={() => handleItemClick(index)}
                            style={{
                              background: item.selected
                                ? "#FFF"
                                : "transparent",
                              margin: "5px",
                              cursor: "pointer",
                              border: "1px solid #ffffff10",
                              borderRadius: "15px",
                              padding: "7px 10px 7px 10px",
                              color: item.selected ? "#000" : "#FFF",
                            }}
                            className="expertice-list-font"
                          >
                            {item.ExpertiseName}
                          </div>
                        );
                      })}
                    </div>
                  </div>
                </div>

                <div className="modal-second-div-title">
                  <div style={{}} className="fontSize16">
                    Bio
                  </div>
                  <div
                    style={{
                      marginTop: "5px",
                      borderRadius: "10px",
                      padding: "10px",
                      border: formErrors.bio
                        ? "1px solid red"
                        : "1px solid rgba(255, 255, 255, 0.2)",
                    }}
                    className="modal-coupon-code-type"
                  >
                    <textarea
                      className="modal-dropdown"
                      type="text"
                      style={{ height: "5rem", flex: 1, paddingLeft: "0rem" }}
                      placeholder="About bio"
                      value={formData.bio}
                      onChange={(e) => handleInputChange(e, "bio")}
                    />
                  </div>
                </div>
              </div>


              <div
                style={{ background: "#25252D" }}
                className="add-inventory-main-div-section"
              >
                <div
                  style={{ display: "flex", justifyContent: "space-between" }}
                >
                  <div className="fontSize24" style={{ fontWeight: 700 }}>
                    Pricing
                  </div>
                </div>

                <div style={{ display: "flex", gap: "20px" }}>
                  <div className="modal-second-div-title">
                    <div style={{}} className="fontSize16">
                      Price per minute
                    </div>
                    <div
                      style={{
                        marginTop: "5px",
                        border: formErrors.priceperminut
                          ? "1px solid red"
                          : "1px solid rgba(255, 255, 255, 0.2)",
                      }}
                      className="modal-coupon-code-type"
                    >
                      <input
                        className="modal-dropdown"
                        type="text"
                        placeholder="₹"
                        value={"₹" + formData.priceperminut}
                        onChange={(e) => handleInputChange(e, "priceperminut")}
                      />
                    </div>
                  </div>
                  <div className="modal-second-div-title">
                    <div style={{}} className="fontSize16">
                      Astrologer's charges
                    </div>
                    <div
                      style={{
                        marginTop: "5px",
                        background: "#FFFFFF1A",
                        border: formErrors.astrologercharge
                          ? "1px solid red"
                          : "1px solid rgba(255, 255, 255, 0.2)",
                      }}
                      className="modal-coupon-code-type"
                    >
                      <input
                        className="modal-dropdown"
                        type="text"
                        disabled
                        placeholder="₹"
                        value={"₹" + formData.astrologercharge}
                        onChange={(e) =>
                          handleInputChange(e, "astrologercharge")
                        }
                      />
                    </div>
                  </div>
                </div>

                <div style={{ display: "flex", gap: "20px" }}>
                  <div className="modal-second-div-title">
                    <div style={{}} className="fontSize16">
                      Discount price
                    </div>
                    <div
                      style={{
                        marginTop: "5px",

                        border: formErrors.discountprice
                          ? "1px solid red"
                          : "1px solid rgba(255, 255, 255, 0.2)",
                      }}
                      className="modal-coupon-code-type"
                    >
                      <input
                        className="modal-dropdown"
                        type="text"
                        placeholder="₹"
                        value={"₹" + formData.discountprice}
                        onChange={(e) => handleInputChange(e, "discountprice")}
                      />
                    </div>
                  </div>
                  <div className="modal-second-div-title">
                    <div style={{}} className="fontSize16">
                      Discount in %
                    </div>
                    <div
                      style={{
                        marginTop: "5px",
                        background: "#FFFFFF1A",
                        border: formErrors.discount_percentage
                          ? "1px solid red"
                          : "1px solid rgba(255, 255, 255, 0.2)",
                      }}
                      className="modal-coupon-code-type"
                    >
                      <input
                        disabled
                        className="modal-dropdown"
                        type="text"
                        placeholder="%"
                        value={formData?.discount_percentage + "%"}
                        onChange={(e) =>
                          handleInputChange(e, "discount_percentage")
                        }
                      />
                    </div>
                  </div>
                </div>
                <div style={{ display: "flex", gap: "20px" }}>
                  <div className="modal-second-div-title">
                    <div style={{}} className="fontSize16">
                      Zigzek margin
                    </div>
                    <div
                      style={{
                        marginTop: "5px",
                        background:
                          formData.discountprice <= 0
                            ? "#FFFFFF1A"
                            : "transparent",
                        border: formErrors.zigzekmargin
                          ? "1px solid red"
                          : "1px solid rgba(255, 255, 255, 0.2)",
                      }}
                      className="modal-coupon-code-type"
                    >
                      <input
                        disabled={formData.discountprice <= 0}
                        className="modal-dropdown"
                        type="text"
                        placeholder="₹"
                        value={"₹" + formData.zigzekmargin}
                        onChange={(e) => handleInputChange(e, "zigzekmargin")}
                      />
                    </div>
                  </div>
                  <div className="modal-second-div-title">
                    <div style={{}} className="fontSize16">
                      Margin in %
                    </div>
                    <div
                      style={{
                        marginTop: "5px",
                        background: "#FFFFFF1A",

                        border: formErrors.marginpercentage
                          ? "1px solid red"
                          : "1px solid rgba(255, 255, 255, 0.2)",
                      }}
                      className="modal-coupon-code-type"
                    >
                      <input
                        className="modal-dropdown"
                        disabled
                        type="text"
                        placeholder="%"
                        value={formData.marginpercentage + "%"}
                        onChange={(e) =>
                          handleInputChange(e, "marginpercentage")
                        }
                      />
                    </div>
                  </div>
                </div>
                {/* <div
                  style={{ display: "flex", marginTop: "10px", gap: "20px" }}
                >
                  <div className="modal-second-div-title">
                    <div style={{}} className="fontSize16">
                      Cost per item
                    </div>
                    <div
                      style={{ marginTop: "5px" }}
                      className="modal-coupon-code-type"
                    >
                      <input
                        className="modal-dropdown"
                        type="text"
                        placeholder="₹"
                        value={formData.cost_per_item}
                        onChange={(e) => handleInputChange(e, "cost_per_item")}
                      />
                    </div>
                  </div>
                  <div className="modal-second-div-title">
                    <div style={{}} className="fontSize16">
                      Profit
                    </div>
                    <div
                      style={{ marginTop: "5px" }}
                      className="modal-coupon-code-type"
                    >
                      <input
                        className="modal-dropdown"
                        type="text"
                        placeholder="₹"
                        value={formData.profit}
                        onChange={(e) => handleInputChange(e, "profit")}
                      />
                    </div>
                  </div>

                  <div className="modal-second-div-title">
                    <div style={{}} className="fontSize16">
                      Margin
                    </div>
                    <div
                      style={{ marginTop: "5px" }}
                      className="modal-coupon-code-type"
                    >
                      <input
                        className="modal-dropdown"
                        type="text"
                        placeholder=""
                        value={formData.margin}
                        onChange={(e) => handleInputChange(e, "margin")}
                      />
                      <div style={{ color: "rgba(255, 255, 255, 0.2)" }}>
                        {"%"}
                      </div>
                    </div>
                  </div>
                </div> */}
              </div>

              {/* <div
                style={{ background: "#25252D" }}
                className="add-inventory-main-div-section"
              >
                <div
                  style={{ display: "flex", justifyContent: "space-between" }}
                >
                  <div className="fontSize24" style={{ fontWeight: 700 }}>
                    Bank details
                  </div>
                </div>
                <div className="modal-second-div-title">
                  <div style={{}} className="fontSize16">
                    Account holder name
                  </div>
                  <div
                    style={{
                      marginTop: "5px",
                      border: formErrors.accountHolderName
                        ? "1px solid red"
                        : "1px solid rgba(255, 255, 255, 0.2)",
                    }}
                    className="modal-coupon-code-type"
                  >
                    <input
                      className="modal-dropdown"
                      type="text"
                      placeholder="Enter name"
                      value={formData.accountHolderName}
                      onChange={(e) =>
                        handleInputChange(e, "accountHolderName")
                      }
                    />
                  </div>
                </div>
                <div className="modal-second-div-title">
                  <div style={{}} className="fontSize16">
                    Bank account number
                  </div>
                  <div
                    style={{
                      marginTop: "5px",
                      border: formErrors.bankAccountNumber
                        ? "1px solid red"
                        : "1px solid rgba(255, 255, 255, 0.2)",
                    }}
                    className="modal-coupon-code-type"
                  >
                    <input
                      className="modal-dropdown"
                      type="text"
                      placeholder="Enter account number"
                      value={formData.bankAccountNumber}
                      onChange={(e) =>
                        handleInputChange(e, "bankAccountNumber")
                      }
                    />
                  </div>
                </div>
                <div className="modal-second-div-title">
                  <div style={{}} className="fontSize16">
                    IFSC code
                  </div>
                  <div
                    style={{
                      marginTop: "5px",
                      border: formErrors.ifscCodeNumber
                        ? "1px solid red"
                        : "1px solid rgba(255, 255, 255, 0.2)",
                    }}
                    className="modal-coupon-code-type"
                  >
                    <input
                      className="modal-dropdown"
                      type="text"
                      placeholder="IFSC code"
                      value={formData.ifscCodeNumber}
                      onChange={(e) => handleInputChange(e, "ifscCodeNumber")}
                    />
                  </div>
                </div>
                <div className="modal-second-div-title">
                  <div style={{}} className="fontSize16">
                    Bank name
                  </div>
                  <div
                    style={{
                      marginTop: "5px",
                      border: formErrors.bankName
                        ? "1px solid red"
                        : "1px solid rgba(255, 255, 255, 0.2)",
                    }}
                    className="modal-coupon-code-type"
                  >
                    <input
                      className="modal-dropdown"
                      type="text"
                      placeholder="Enter bank name"
                      value={formData.bankName}
                      onChange={(e) => handleInputChange(e, "bankName")}
                    />
                  </div>
                </div>
              </div> */}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default AddAgentAstrologers;